module.exports = __webpack_public_path__ + "static/img/XC30.e080711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XC30.png
// module id = LJgO
// module chunks = 2